"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SVG_1 = __importDefault(require("./SVG"));
const Icon = (0, styled_components_1.default)(SVG_1.default) `
    polygon {
        fill: ${({ theme }) => theme.colorControlIcon};
    }
`;
exports.default = (props) => (react_1.default.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 7 12", width: "7px", height: "12px" }),
    react_1.default.createElement("polygon", { points: "7 4 3.5 0 0 4 3 4 3 12 4 12 4 4 7 4" })));
//# sourceMappingURL=Asc.js.map